import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { MaterialModule } from '../material/material.module';
import { MatIconModule } from '@angular/material/icon';
import { PasswordResetModule } from '../password-reset/password-reset.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    PasswordResetModule,
  ],
  exports: [
    LoginComponent
  ]
})
export class LoginModule { }